import { useEffect } from 'react';

import { useAppSelector } from 'shared/lib/redux';

import { useAssignmentActionTimestampHandlers } from './use-assignment-action-timestamp-handlers';

export const useAssignmentsQueryInvalidation = (
  invalidationCallback: () => void,
) => {
  const assignmentActionTimestamp = useAppSelector(
    (state) => state.assignmentPanel.assignmentActionTimestamp,
  );

  const { clearAssignmentActionTimestamp } =
    useAssignmentActionTimestampHandlers();

  useEffect(() => {
    if (!assignmentActionTimestamp) return;

    invalidationCallback();

    /*
     * reset timestamp of last assignment action
     * to avoid errors after pages changing
     * */
    clearAssignmentActionTimestamp();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assignmentActionTimestamp]);
};
